// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".intercom-app .intercom-messenger-frame {\n  top: 85px;\n}\n", "",{"version":3,"sources":["webpack://./src/application-wide/navigation/SaplingIntercomProvider.less"],"names":[],"mappings":"AAAA;EAEI,SAAA;AAAJ","sourcesContent":[".intercom-app {\n  .intercom-messenger-frame {\n    top: 85px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
